import { request } from "./request";
//登录
export const requestt = (data) => {
  return request({
    url: "/api/member/pay/login",
    method: "post",
    data,
  });
};
//登出
export const logout = () => {
  return request({
    url: "/api/member/pay/logout",
    method: "post",
  });
};
//自动登录
export const Automaticlogon = (data) => {
  return request({
    url: "/api/member/user/web/autoLogin",
    method: "post",
    data,
  });
};
//获取服务角色信息
export const TheServer = (gameId) => {
  return request({
    url: `/api/pay/player/serverRoleInfo/${gameId}`,
    method: "get",
  });
};
// //获取充值说明配置
// export const RedePtion = (gameIds)=>{
//   return request({
//     url:`/api/pay/config/policy/${gameIds}`,
//     method:"get",
//   })
// }
//获取购买列表s
export const PuList = (gameId) => {
  return request({
    url: `/api/pay/config/product/${gameId}`,
    method: "get",
  });
};
//获取购买列表s
export const payMode = (gameId) => {
  return request({
    url: `/api/pay/config/getPaymentType/${gameId}`,
    method: "get",
  });
};
//点击跳转第三方支付
export const requestHttp = ({ url, data }) => {
  return request({
    url,
    method: "post",
    data,
  });
};

//不需要登录的接口
// 获取游戏名和是否开启区服列表
export const GameNamelist = (gameId) => {
  return request({
    url: `/api/pay/config/${gameId}`,
    method: "get",
  });
};
// 校验用户角色信息
export const checkRole = (data) => {
  return request({
    url: "/api/pay/player/roleInfo",
    method: "post",
    data,
  });
};

// 新接口页面

// 获取充值说明配置
export const RedePtion = (gameIds) => {
  return request({
    url: `/api/pay/game/getGameConfig/${gameIds}`,
    method: "get",
  });
};

//获取服务角色信息
export const TheServer2 = (gameId) => {
  return request({
    url: `/api/pay/player/serverRoleInfo/${gameId}`,
    method: "get",
  });
};

export const TheServer3 = (gameId) => {
  return request({
    url: `/api/pay/player/serverInfo/${gameId}`,
    method: "get",
  });
};

export const checkGolegame = (data) => {
  return request({
    url: `/api/pay/game/checkGameRole`,
    method: "post",
    data,
  });
};

// 网页获取版本最新信息
export const getNewestVersion = () => {
  return request({
    url: `/api/pay/function/newestVersion`,
    method: "get",
  });
};

// 新增  ustore
// 充值页面展示的游戏相关信息
export const getGameConfigNew = (gameIds) => {
  return request({
    url: `/api/pay/function/getGameConfig/${gameIds}`,
    method: "get",
  });
};
// 查询服务器列表  用作cps中
export const serverList = (gameId) => {
  return request({
    url: `/api/pay/player/roleInfo/bind/serverList/${gameId}`,
    method: "get",
  });
};
// 获取角色信息 
export const functionServerRoleInfo = (gameId) => {
  return request({
    url: `/api/pay/function/serverRoleInfo/${gameId}`,
    method: "get",
  });
};
//自动登录
export const memberPayAutoLogin = (data) => {
  return request({
    url: "/api/member/pay/autoLogin",
    method: "post",
    data,
  });
};

// 获取商品列表
export const functionGetGoodsList = (data) => {
  return request({
    url: `/api/pay/function/getGoodsList`,
    method: "post",
    data,
  });
};
// 登录
export const memberPayUstoreLogin = (data) => {
  return request({
    url: "/api/member/pay/ustore/login/v2",
    method: "post",
    data,
  });
};
// 登出
export const memberPayLogout = () => {
  return request({
    url: "/api/member/pay/logout",
    method: "post",
  });
};
// 获取用户信息 
export const functionUserInfo = () => {
  return request({
    url: `/api/pay/function/userInfo`,
    method: "get",
  });
};
// 校验
export const roleInfoBindCheck = (data) => {
  return request({
    url: "/api/pay/player/roleInfo/bind/check",
    method: "post",
    data,
  });
};
// 商品详情
export const functionGetPayGoodsInfo = (data) => {
  return request({
    url: "/api/pay/function/getPayGoodsInfo",
    method: "post",
    data,
  });
};
// 获取支付方式
export const functionPayChannel = (gameId) => {
  return request({
    url: `/api/pay/function/payChannelV2/${gameId}`,
    method: "get",
  });
};
// 预计获取的积分
export const functionPayPoints = (data) => {
  return request({
    url: "/api/pay/function/payPoints",
    method: "post",
    data,
  });
};
// 创建订单
export const payOrderApply = (data) => {
  return request({
    url: "/api/pay/order/apply",
    method: "post",
    data,
  });
};

